<template>
  <div class="consider__plan__form">
    <div class="text-center mb-4">
      <div class="font-32 font-w-700 font-ch">แบบฟอร์มพิจารณาแผนงาน</div>
      <div class="font-20 font-w-700 font-ch" style="color: #f7941d">
        (Consider Form)
      </div>
    </div>

    <div class="text-center font-20 font-w-500 font-ch px-16 mb-6">
      เกณฑ์การพิจารณาแผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่
      (IRTC) ประจำปีงบประมาณ 2566
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card flat class="pa-6 section_form mb-3">
        <v-layout align-center class="font-14 font-w-500 font-ch">
          <v-flex shrink>
            <span class="mr-2">รหัสแผนงาน</span>
            <span class="text__orange">{{ form.plan_code }}</span>
          </v-flex>
          <v-flex shrink class="mx-12">
            <span class="text__orange">
              {{ form.plan_region }}
            </span>
          </v-flex>
          <v-flex shrink>
            <span>
              <span class="mr-2">ผู้พิจารณา</span>
              <span class="text__orange">{{ form.evaluator_name }}</span>
            </span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <span>
              <span class="mr-2">วันที่</span>
              <span class="text__orange">{{ date }}</span>
            </span>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- Table -->
      <v-card flat class="pa-4 section_form mb-3">
        <table class="custom_table">
          <thead>
            <tr>
              <th
                class="text-center font-12"
                style="border-right: thin solid #d3d3d3"
                width="5%"
              >
                ลำดับ
              </th>
              <th
                class="text-center font-12"
                style="border-right: thin solid #d3d3d3"
                width="70%"
              >
                ประเภท/รายละเอียด
              </th>
              <th
                class="text-center font-12"
                style="border-right: thin solid #d3d3d3"
                width="10%"
              >
                คะแนน
              </th>
              <th class="text-center font-12" width="25%">ผลการประเมิน</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in form.details"
              :key="i"
              style="vertical-align: top"
            >
              <td
                class="text-center py-3"
                style="
                  border-right: thin solid #d3d3d3;
                  border-bottom: 1px solid #d3d3d3;
                "
                width="5%"
              >
                {{ i + 1 }}.
              </td>
              <td
                style="
                  border-right: thin solid #d3d3d3;
                  border-bottom: 1px solid #d3d3d3;
                "
                width="70%"
                class="py-3"
              >
                <!-- main detail -->
                <div style="height: 40px">{{ item.plan_name }}</div>
                <!-- sub detail -->
                <div
                  style="height: 50px"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="d-flex align-center"
                >
                  <div>
                    <span class="mr-2">{{ i + 1 }}.{{ j + 1 }}</span>
                    <span>{{ sub.name }}</span>
                  </div>
                </div>
              </td>
              <td
                class="text-center py-3"
                style="
                  border-right: thin solid #d3d3d3;
                  border-bottom: 1px solid #d3d3d3;
                "
                width="10%"
              >
                <!-- main detail -->
                <div style="height: 40px" class="text__orange">
                  {{ item.max_score }}
                </div>
                <!-- sub detail -->
                <div
                  style="height: 50px"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="text-center d-flex align-center justify-center"
                >
                  <span>{{ sub.max_score }}</span>
                </div>
              </td>
              <td
                class="text-center"
                width="25%"
                style="border-bottom: 1px solid #d3d3d3"
              >
                <!-- main detail -->
                <div style="height: 40px">
                  <v-text-field
                    v-model="item.score"
                    outlined
                    dense
                    class="text-center"
                    hide-details
                    height="30"
                    type="number"
                    color="#D3D3D3"
                    style="border-radius: 30px"
                    :placeholder="item.sub_details.length > 0 ? '' : 'โปรดระบุ'"
                    :disabled="item.sub_details.length > 0"
                    :background-color="
                      item.sub_details.length > 0 ? '#FAFAFA' : ''
                    "
                    :rules="[(v) => !!v || 'กรุณาระบุรหัสแผนงาน']"
                    required
                  ></v-text-field>
                </div>
                <!-- sub detail -->
                <div
                  style="height: 50px"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="text-center d-flex align-center"
                >
                  <v-text-field
                    v-model="sub.score"
                    placeholder="โปรดระบุ"
                    outlined
                    dense
                    class="text-center"
                    type="number"
                    hide-details
                    height="30"
                    color="#D3D3D3"
                    style="border-radius: 30px"
                    :rules="[(v) => !!v || 'กรุณาระบุรหัสแผนงาน']"
                    required
                    @input="calculateTotalScore(i, j, sub.score)"
                  ></v-text-field>
                </div>
              </td>
            </tr>

            <tr>
              <td style="border-right: thin solid #d3d3d3"></td>
              <td style="border-right: thin solid #d3d3d3" class="text-center">
                <span class="mr-2">คะแนนรวม</span>
              </td>
              <td style="border-right: thin solid #d3d3d3" class="text-center">
                <span class="text__orange">{{ form.overall_score }}</span>
              </td>
              <td class="text-center">
                <span class="text__orange">{{ form.total_score }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card>

      <!--  ความคิดเห็น/ข้อเสนอเเนะ -->
      <v-card flat class="pa-4 section_form mb-3">
        <div class="font-14 font-w-500 font-ch mb-2">
          ความคิดเห็น/ข้อเสนอเเนะ
        </div>
        <v-textarea
          v-model="form.feedback"
          outlined
          dense
          rows="5"
          color="#D3D3D3"
          style="border-radius: 30px"
          placeholder="โปรดระบุ"
          :rules="[(v) => !!v || 'กรุณาระบุความคิดเห็น/ข้อเสนอเเนะ']"
          required
        ></v-textarea>
      </v-card>

      <div class="font-14 font-w-500 font-ch mb-5" style="color: #f15a29">
        หมายเหตุ : แบบประเมินหากทำการลงคะเเนนแล้วไม่สามารถแก้ไขได้
      </div>

      <v-layout justify-space-between align-center>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            @click="$router.push({ name: 'ConsiderFormList' })"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_orange_gradient"
            @click="submitForm"
            :loading="loadingBtn"
          >
            <Icon icon="fluent:mail-edit-24-filled" style="color: #ffffff" />
            <span class="font-14 font-w-700 font-ch ml-2">พิจารณา</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="dialog" width="500">
      <v-card class="pa-6">
        <div class="text-center">
          <!-- icon success -->
          <v-icon color="#59CB33" size="70" class="mx-auto">
            mdi-check-circle
          </v-icon>
        </div>

        <div class="font-24 font-w-700 font-ch text-center mt-6">
          {{ dialogMsg }}
        </div>

        <div class="d-flex justify-center mt-12">
          <v-btn
            dark
            color="#F15A29"
            width="100"
            rounded
            depressed
            @click="confirmDialog"
          >
            <div class="font-16 font-w-700 font-ch text-center">ตกลง</div>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- <pre>
        {{ form }}
    </pre> -->
  </div>
</template>

<script>
import Service from "../../services";
import { Icon } from "@iconify/vue2";
import moment from "moment";

export default {
  name: "EvaluateForm",
  components: {
    Icon,
  },
  data() {
    return {
      date: moment().add(543, "year").format("DD/MM/YYYY"),
      valid: true,
      loadingBtn: false,
      dialog: false,
      dialogMsg: "บันทึกสำเร็จ",
      form: {
        layout_id: null,
        plan_id: null,
        form_b_id: null,
        plan_code: null,
        plan_region: null,
        evaluator_id: null,
        evaluator_name: null,
        evaluate_date: moment().format("YYYY-MM-DD"),
        overall_score: 0,
        total_score: 0,
        feedback: null,
        details: [
          //   {
          //     consider_id: null,
          //     plan_name: null,
          //     max_score: null,
          //     score: null,
          //     sub_details: [
          //       {
          //         name: null,
          //         max_score: null,
          //         score: null,
          //       },
          //     ],
          //   },
        ],
      },
    };
  },
  computed: {
    user: function () {
      return this.$store.state.Auth.User;
    },
  },
  created() {
    this.form.form_b_id = this.$route.params.id;
    this.fetchForm();

    // const formB = {
    //   region: "ภาคเหนือ",
    //   plan: {
    //     id: 2,
    //     evaluate_layout: {
    //       id: 1,
    //       overall_score: 100,
    //       plan_code: "SP",
    //       plan_id: 1,
    //       plan_name: "แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์",
    //       status: "active",
    //       year: 2566,
    //       details: [
    //         {
    //           criteria_no: "1",
    //           criteria_type: "head",
    //           id: 1,
    //           layout_id: 1,
    //           max_score: 20,
    //           name: "กลุ่มเป้าหมายในพื้นที่ (Demand side)",
    //           sub_details: [
    //             {
    //               criteria_no: "1.1",
    //               id: 1,
    //               layout_detail_id: 1,
    //               max_score: 10,
    //               name: "มีความต้องการในการเข้าร่วมโครงการจากกลุ่มธุรกิจ/อุตสาหกรรมเป้าหมาย (เช่น รายชื่อลูกค้า กิจกรรมและผลการดำเนินงานต่างๆ ที่เกี่ยวข้อง เป็นต้น)",
    //             },
    //             {
    //               criteria_no: "1.2",
    //               id: 2,
    //               layout_detail_id: 1,
    //               max_score: 10,
    //               name: "วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)",
    //             },
    //           ],
    //         },
    //         {
    //           criteria_no: "2",
    //           criteria_type: "head",
    //           id: 2,
    //           layout_id: 1,
    //           max_score: 100,
    //           name: "ศักยภาพและความพร้อมในการดำเนินงานของอุทยานฯ (Supply side)",
    //           sub_details: [
    //             {
    //               criteria_no: "2.1",
    //               id: 3,
    //               layout_detail_id: 2,
    //               max_score: 10,
    //               name: "วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)",
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //   },
    // };

    // // set data to form
    // this.form.layout_id = formB?.plan?.evaluate_layout?.id;
    // this.form.plan_id = formB?.plan?.id;
    // this.form.plan_code = formB?.plan?.evaluate_layout?.plan_code;
    // this.form.plan_region = formB?.region;
    // this.form.evaluator_name = this.user?.name
    //   ? this.user?.name
    //   : "Unknown User";
    // this.form.evaluator_id = this.user?.id ? this.user?.id : 1;
    // this.form.evaluate_date = moment().add(543, "year").format("DD/MM/YYYY");
    // this.form.overall_score = formB?.plan?.evaluate_layout?.overall_score;
    // this.form.details = formB?.plan?.evaluate_layout?.details.map((item) => {
    //   return {
    //     plan_name: item.name,
    //     max_score: item.max_score,
    //     score: null,
    //     sub_details: item.sub_details.map((sub) => {
    //       return {
    //         name: sub.name,
    //         max_score: sub.max_score,
    //         score: null,
    //       };
    //     }),
    //   };
    // });

    // console.log("form", this.form);
  },
  watch: {
    form: {
      handler: function (val) {
        // console.log(val);
        // sum score details and sub_details
        if (this.form.details.length > 0) {
          this.form.total_score = this.form.details.reduce((acc, cur) => {
            return acc + +cur.score;
          }, 0);
        }
      },
      deep: true,
    },
  },
  methods: {
    async fetchForm() {
      const res = await this.$apiFire(
        "Consider/getEvaluateForm",
        this.$route.params.id
      );
      console.log("fetchForm", res);
      if (res) {
        const formB = res.formB;
        // set data to form
        this.form.layout_id = formB?.plan?.evaluate_layout?.id;
        this.form.plan_id = formB?.plan?.id;
        this.form.plan_code = formB?.plan?.evaluate_layout?.plan_code;
        this.form.plan_region = formB?.region;
        this.form.evaluator_name = this.user?.name
          ? this.user?.name
          : "Unknown User";
        this.form.evaluator_id = this.user?.id ? this.user?.id : 1;
        this.form.overall_score = formB?.plan?.evaluate_layout?.overall_score;
        if (formB?.plan?.evaluate_layout?.details) {
          this.form.details = formB?.plan?.evaluate_layout?.details.map(
            (item) => {
              return {
                plan_name: item.name,
                max_score: item.max_score,
                score: null,
                sub_details: item.sub_details.map((sub) => {
                  return {
                    name: sub.name,
                    max_score: sub.max_score,
                    score: null,
                  };
                }),
              };
            }
          );
        }
      }
    },
    async submitForm() {
      console.log("submitForm", this.form);
      if (this.$refs.form.validate()) {
        const res = await this.$apiFire("Consider/saveEvaluateForm", this.form);
        console.log("fetchForm", res);
        if (res) {
          this.$router.push({ name: "ConsiderFormList" });
        }
      }
    },
    confirmDialog() {
      this.dialog = false;
      //   this.$router.push({ name: "ConsiderFormList" });
    },
    calculateTotalScore(mainIndex, subIndex, val) {
      // sum max score in details to overall score
      this.form.details[mainIndex].score = this.form.details[
        mainIndex
      ].sub_details.reduce((acc, cur) => {
        return acc + +cur.score;
      }, 0);

      this.form.details[mainIndex].score =
        this.form.details[mainIndex].score == 0
          ? null
          : this.form.details[mainIndex].score;
    },
  },
};
</script>

<style lang="scss">
.consider__plan__form {
  .section_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px;
  }
  .text__orange {
    color: #f15a29;
  }
  .custom_table {
    border: thin solid #d3d3d3;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
  .btn_orange_gradient {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
  .v-text-field__slot {
    input {
      text-align: center !important;
    }
  }
  .custom_table {
    width: 100%;
    border-spacing: 0px;
    th {
      padding: 10px;
      border-bottom: 1px solid #d3d3d3;
    }
    td {
      padding: 10px;
    }
  }
}
</style>
